import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useSetOnLoginUrl } from 'lib-core'

// Sends an unauthenticated visitor to the standalone sign-in page, having
// first captured the current URL via useSetOnLoginUrl so a successful login
// returns them here (see useOnLoginSuccess in lib-core).
const RedirectToLogin = () => {
  useSetOnLoginUrl()
  const history = useHistory()

  useEffect(() => {
    history.push('/welcome/login/email#?state=login')
  }, [])

  return null
}

export default RedirectToLogin
